import { TwoUserStack } from "@circle-react-uikit/TwoUserStack";
import type { Notification } from "@circle-react/types/Notification";

import { NotificationTypeIcon } from "./UserImageWithIcon/NotificationTypeIcon";

export interface GroupUserImageProps {
  notification: Notification;
}

export const GroupUserImage = ({ notification }: GroupUserImageProps) => (
  <div className="border-tertiary group-hover:border-hover relative mr-2.5">
    <TwoUserStack
      users={[
        {
          name: notification.actor_name,
          src: notification.actor_image || "",
        },
        {
          name: notification.second_actor_name || "",
          src: notification.second_actor_image || "",
        },
      ]}
      isFullRounded
    />
    <NotificationTypeIcon action={notification.action} />
  </div>
);
